"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[863],{

/***/ 40863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ templates_Auth; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/CardLogin/index.tsx + 1 modules
var CardLogin = __webpack_require__(59472);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/ui/Button/index.tsx
var Button = __webpack_require__(34636);
// EXTERNAL MODULE: ./src/components/ui/Form/index.tsx
var Form = __webpack_require__(96866);
// EXTERNAL MODULE: ./src/components/ui/TextField/index.tsx
var TextField = __webpack_require__(18316);
// EXTERNAL MODULE: ./src/core/const/routes.ts
var routes = __webpack_require__(92819);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx
var useAuth = __webpack_require__(83276);
// EXTERNAL MODULE: ./node_modules/@react-oauth/google/dist/index.esm.js
var dist_index_esm = __webpack_require__(86426);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
;// CONCATENATED MODULE: ./src/components/FormLogin/index.tsx

















var schema = es/* object */.Ry({
    login: es/* string */.Z_().min(2).required().label("email"),
    password: es/* string */.Z_().required().label("password")
}).required();
var FormLogin = function(param) {
    var setModalUrl = param.setModalUrl;
    var handleExpired = function handleExpired() {
        setIsVerified(false);
    };
    var ref = (0,useAuth/* default */.Z)(), signIn = ref.signIn, loading = ref.loading, logado = ref.logado, signInGoogle = ref.signInGoogle, usuario = ref.usuario;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isMobileResolution = ref1[0], setIsMobileResolution = ref1[1];
    var ref2 = (0,react.useState)(), sizeMobile = ref2[0], setSizeMobile = ref2[1];
    var ref3 = (0,react.useState)(false), isVerified = ref3[0], setIsVerified = ref3[1];
    var ref4 = (0,react.useState)(""), recaptchaToken = ref4[0], setRecaptchaToken = ref4[1];
    var idPerfilCliente = "70493d60-1526-46f2-95ee-309e7b2d1b47";
    var ref5 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema),
        defaultValues: {
            login: "",
            password: ""
        }
    }), handleSubmit = ref5.handleSubmit, control = ref5.control, errors = ref5.formState.errors;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var success, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            signIn({
                                usuario: data.login,
                                senha: data.password,
                                recaptchaToken: recaptchaToken
                            })
                        ];
                    case 1:
                        success = _state.sent();
                        if (!success) {
                            ;
                            (ref = recaptchaRef.current) === null || ref === void 0 ? void 0 : ref.reset();
                            setIsVerified(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var onLoginGoogle = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            signInGoogle({
                                token: data.token
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onLoginGoogle(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var checkResolution = function() {
            var WindowTela = window.innerWidth;
            switch(true){
                case WindowTela <= 490:
                    setIsMobileResolution(true);
                    break;
                case WindowTela <= 768:
                    setSizeMobile(400);
                    break;
                case WindowTela >= 768:
                    setIsMobileResolution(false);
                    setSizeMobile(500);
                    break;
                default:
                    setIsMobileResolution(false);
                    setSizeMobile(500);
                    break;
            }
        };
        checkResolution() // Check initial resolution
        ;
        window.addEventListener("resize", checkResolution) // Add event listener for resize
        ;
        return function() {
            window.removeEventListener("resize", checkResolution) // Cleanup event listener on component unmount
            ;
        };
    }, []);
    (0,react.useEffect)(function() {
        var userCliente = usuario && usuario.perfil === idPerfilCliente;
        if (logado) {
            if (usuario && usuario.usuarioIncompleto && userCliente) {
                router.replace(routes/* routes.cadastroAtualizar */._.cadastroAtualizar);
            } else {
                router.replace(routes/* routes.minhasConsultorias */._.minhasConsultorias);
            }
        }
    }, [
        logado
    ]);
    var recaptchaRef = (0,react.useRef)(null);
    var handleChange = function(token) {
        if (token) {
            setRecaptchaToken(token);
            setIsVerified(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Acessar \xe1rea do cliente"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormWrapper */.n, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "my-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                type: "email",
                                control: control,
                                label: "Email",
                                error: errors.login && "Campo obrigat\xf3rio *",
                                name: "login",
                                className: "my-2",
                                inputDefauld: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            className: "my-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                control: control,
                                label: "Senha",
                                error: errors.password && "Campo obrigat\xf3rio *",
                                name: "password",
                                type: "password",
                                className: "my-2",
                                inputDefauld: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-5 mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex justify-content-center align-items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                        sitekey: "6LcLqOIqAAAAAGNCCiavSXv_CjrzgAsbv-XZ3lEd" || 0,
                                        ref: recaptchaRef,
                                        onChange: handleChange,
                                        onExpired: handleExpired
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    loading: loading,
                                    loadingText: "Entrando",
                                    size: "large",
                                    fullWidth: true,
                                    disabled: !isVerified,
                                    children: "Acessar"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Ou entrar com: "
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GoogleLogin */.kZ, {
                                            width: sizeMobile,
                                            type: "".concat(isMobileResolution ? "icon" : "standard"),
                                            onSuccess: function(credentialResponse) {
                                                if (credentialResponse.credential) {
                                                    var data = {
                                                        token: credentialResponse.credential
                                                    };
                                                    onLoginGoogle(data);
                                                } else {
                                                    console.log("token google n\xe3o encontrado");
                                                }
                                            },
                                            onError: function() {
                                                console.log("Login Failed");
                                            },
                                            useOneTap: true
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: "20px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormLink */.K, {
                                    style: {
                                        float: "none",
                                        margin: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: routes/* routes.recuperarSenha */._.recuperarSenha,
                                        title: "Redefinir senha",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "Esqueceu sua senha?"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* FormLink */.K, {
                                    style: {
                                        float: "none",
                                        margin: 0,
                                        fontWeight: 600
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: routes/* routes.primeiroAcesso */._.primeiroAcesso,
                                        title: "Primeiro acesso",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: "Primeiro acesso"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_FormLogin = (FormLogin);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-media-query/dist/styled-media-query.es.js
var styled_media_query_es = __webpack_require__(60605);
;// CONCATENATED MODULE: ./src/templates/Auth/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* background-image: url('img/fundo-login.png');\n    background-size: cover;\n    background-repeat: no-repeat; */\n    background-color: ",
        ";\n    width: 100%;\n    min-height: calc(100vh - 96px);\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 100%;\n    max-width: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: calc(",
        " / 2);\n    padding-right: calc(",
        " / 2);\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: calc(100vh - 96px);\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: auto;\n    justify-content: start;\n    display: flex;\n    flex-direction: row;\n    padding-left: 5px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 700px;\n    padding-left: 45px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 600px;\n  min-height: calc(100vh - 96px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  margin: 0;\n  padding-left: 25px;\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: 0px;\n    min-height: calc(100vh - 300px);\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: calc(100vh - 96px);\n  background: #f8eff8;\n  border-radius: 20px;\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-height: 100%;\n  max-width: 400px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: 24px;\n      margin-bottom: 10px;\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-size: 46px;\n    font-weight: 500;\n    line-height: 1.2;\n    margin-bottom: 45px;\n\n    span {\n      color: ",
        ";\n      &.primary {\n        color: ",
        ";\n      }\n    }\n    ",
        "\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:80%;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: end;\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position:sticky;\n    opacity: 1;\n    animation: none;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  opacity: 0;\n  animation: fadeInLeft 1s ease-out forwards;\n  animation-delay: 3.5s;\n  img {\n    width: 100%;\n  }\n  @keyframes fadeInLeft {\n    from {\n      opacity: 0;\n      transform: translateX(-50px); /* Mova a div 50px para a esquerda */\n    }\n    to {\n      opacity: 1;\n      transform: translateX(\n        0px\n      ); /* Mova a div de volta para a posi\xe7\xe3o original */\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.colors.white);
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-1"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), theme.grid.container, theme.grid.gutter, theme.grid.gutter);
});
var BoxContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-2"
})(_templateObject4());
var BoxTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-3"
})(_templateObject7(), styled_media_query_es/* default.lessThan */.ZP.lessThan("small")(_templateObject5()), styled_media_query_es/* default.greaterThan */.ZP.greaterThan("huge")(_templateObject6()));
var BoxLogin = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-4"
})(_templateObject9(), styled_media_query_es/* default.lessThan */.ZP.lessThan("small")(_templateObject8()));
var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-5"
})(_templateObject10());
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-f3b6dd49-6"
})(_templateObject13(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), theme.colors.black, theme.colors.secondary, theme.colors.primary, styled_media_query_es/* default.lessThan */.ZP.lessThan("small")(_templateObject11()));
});
var BoxCart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-7"
})(_templateObject14());
var BoxTinta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-8"
})(_templateObject16(), styled_media_query_es/* default.lessThan */.ZP.lessThan("small")(_templateObject15()));
var BoxImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3b6dd49-9"
})(_templateObject18(), styled_media_query_es/* default.lessThan */.ZP.lessThan("small")(_templateObject17()));

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./src/components/HeaderLogin/index.tsx + 1 modules
var HeaderLogin = __webpack_require__(16018);
// EXTERNAL MODULE: ./src/components/ui/MediaMatch/index.tsx
var MediaMatch = __webpack_require__(14247);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/img/logo-login.png
var logo_login = __webpack_require__(74062);
;// CONCATENATED MODULE: ./src/components/ui/AnimaBalde/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0;\n  animation: ",
        " 0.5s ease-in-out forwards;\n  animation-delay: ",
        "s;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

// Definição da animação de fade-in
var fadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(styles_templateObject());
// Estilizando os paths para incluir a animação com delay variável
var AnimatedPath = styled_components_browser_esm/* default.path.withConfig */.ZP.path.withConfig({
    componentId: "sc-4998c664-0"
})(styles_templateObject1(), fadeIn, function(props) {
    return props.delay;
});

;// CONCATENATED MODULE: ./src/components/ui/AnimaBalde/index.tsx



var AnimaBalde = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "220",
        height: "92",
        viewBox: "0 0 296 92",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 1,
                d: "M10.2393 83.2081C22.5665 90.4604 42.5333 90.4604 54.8605 83.2081C67.1877 75.9559 67.1715 64.2266 54.8605 56.9744C42.5496 49.7221 22.5503 49.7221 10.2393 56.9744C-2.07166 64.2266 -2.08788 75.9724 10.2393 83.2081Z",
                fill: "#833D90"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 1.5,
                d: "M112.49 91.3686C144.121 91.3686 169.763 76.2876 169.763 57.6843C169.763 39.081 144.121 24 112.49 24C80.8592 24 55.2173 39.081 55.2173 57.6843C55.2173 76.2876 80.8592 91.3686 112.49 91.3686Z",
                fill: "#833D90"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 2,
                d: "M213.817 91.3686C245.447 91.3686 271.089 76.2876 271.089 57.6843C271.089 39.081 245.447 24 213.817 24C182.186 24 156.544 39.081 156.544 57.6843C156.544 76.2876 182.186 91.3686 213.817 91.3686Z",
                fill: "#833D90"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 2.5,
                d: "M278.534 75.3779C280.72 76.5096 283.138 77.0995 285.59 77.0995C288.042 77.0995 290.46 76.5096 292.646 75.3779C296.555 73.0816 296.555 69.3646 292.646 67.1179C290.459 65.9901 288.042 65.4023 285.59 65.4023C283.139 65.4023 280.721 65.9901 278.534 67.1179C274.642 69.3316 274.642 73.0486 278.534 75.3779Z",
                fill: "#833D90"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 0,
                d: "M59.9561 15.9339L7.24105 15.207L6.7869 59.0511C6.7869 63.0159 9.28477 67.0138 14.3941 70.0865C24.6127 76.265 41.3031 76.4467 51.7001 70.4995C56.9229 67.5094 59.5343 63.528 59.5343 59.5137L59.9561 15.9339Z",
                fill: "#37474F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 0,
                d: "M15.0915 4.33733C4.72696 10.2845 4.62964 20.0974 14.8645 26.2593C25.0993 32.4213 41.7734 32.603 52.1705 26.6723C62.5675 20.7417 62.6324 10.9123 52.3975 4.75033C42.1627 -1.41163 25.4399 -1.60987 15.0915 4.33733Z",
                fill: "#455A64"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 0,
                d: "M57.6852 15.7531C57.6795 16.4744 57.5534 17.1894 57.3122 17.8676C56.1076 20.8449 53.8585 23.2593 51.0026 24.6408C45.5815 27.4746 39.5431 28.8614 33.4526 28.6717C27.3676 28.7277 21.3682 27.2101 16.0161 24.2609C13.245 22.8297 11.078 20.423 9.91735 17.4877C9.66626 16.7607 9.54006 15.9951 9.54429 15.2244C9.54429 11.9204 11.9449 8.79813 16.2269 6.38621C21.6233 3.51596 27.6607 2.12673 33.7445 2.35533C39.843 2.27164 45.8596 3.79084 51.2135 6.76619C55.4307 9.31027 57.7177 12.4821 57.6852 15.7531Z",
                fill: "#263238"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 0,
                d: "M57.3122 17.8668C56.1076 20.8441 53.8585 23.2584 51.0026 24.64C45.5815 27.4737 39.5432 28.8606 33.4526 28.6708C27.3676 28.7269 21.3682 27.2092 16.0161 24.26C13.245 22.8289 11.078 20.4222 9.91736 17.4868C11.1132 14.5078 13.3656 12.0958 16.2269 10.7302C21.6285 7.87115 27.6601 6.47189 33.7445 6.66625C39.8459 6.62706 45.8569 8.16755 51.2135 11.1432C53.9767 12.5609 56.143 14.9492 57.3122 17.8668Z",
                fill: "#BA68C8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 0,
                opacity: "0.15",
                d: "M51.0026 24.6404C51.8412 24.1499 52.6435 23.5978 53.4032 22.9884C43.7847 28.2583 27.2403 26.0445 22.0824 21.9145C16.9244 17.7845 16.2269 10.7305 24.6127 7.5752C21.6795 8.18181 18.8527 9.23436 16.2269 10.6975C13.3656 12.0632 11.1132 14.4751 9.91736 17.4542C11.078 20.3895 13.245 22.7962 16.0161 24.2274C21.3682 27.1766 27.3676 28.6942 33.4526 28.6382C39.5404 28.8381 45.5785 27.4627 51.0026 24.6404Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 0,
                d: "M44.839 32.3552C45.9906 31.6944 46.9152 32.2561 46.899 33.6107C46.8507 34.3422 46.6349 35.0519 46.2687 35.6831C45.9025 36.3142 45.3962 36.8492 44.7904 37.2451C43.6225 37.9224 42.698 37.3607 42.7142 36.0061C42.763 35.2706 42.9807 34.5571 43.3498 33.923C43.7189 33.2888 44.229 32.7518 44.839 32.3552Z",
                fill: "#263238"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 0,
                d: "M7.12753 22.9054C4.22415 28.7205 -1.53395 42.5643 5.94347 48.2141L6.86801 48.8584V51.6502C6.12189 51.1877 5.35955 50.659 4.61343 50.1139C-6.57837 41.6722 6.04078 19.9979 6.59226 19.0893C6.65784 18.9694 6.74606 18.8639 6.85184 18.7788C6.95762 18.6938 7.07887 18.6309 7.20862 18.5938L7.12753 22.9054Z",
                fill: "#E0E0E0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedPath, {
                delay: 0,
                d: "M45.8122 35.3615C45.504 36.0223 37.3616 51.8815 23.9639 55.0698C22.4506 55.4447 20.8986 55.6333 19.3412 55.6315C14.8959 55.5423 10.5682 54.161 6.86801 51.6502V48.8583C12.399 52.757 17.9625 54.1117 23.4124 52.8231C35.7721 49.866 43.6874 34.4198 43.7523 34.2711C43.8939 33.9991 44.1348 33.7946 44.4231 33.7019C44.7114 33.6092 45.0239 33.6356 45.2932 33.7756C45.4352 33.8384 45.5626 33.931 45.6671 34.0473C45.7717 34.1636 45.851 34.301 45.9 34.4506C45.9489 34.6002 45.9664 34.7586 45.9513 34.9155C45.9362 35.0725 45.8888 35.2244 45.8122 35.3615Z",
                fill: "#E0E0E0"
            })
        ]
    });
};
/* harmony default export */ var ui_AnimaBalde = (AnimaBalde);

;// CONCATENATED MODULE: ./src/templates/Auth/index.tsx













var Auth = function() {
    var ref = (0,react.useState)(false), modalUrl = ref[0], setModalUrl = ref[1];
    var ref1 = (0,useAuth/* default */.Z)(), usuario = ref1.usuario, signOut = ref1.signOut, logado = ref1.logado;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLogin/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-fluid",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxContent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                lg: 6,
                                className: "p-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                                        lessThan: "small",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex justify-content-center w-100",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                width: 68,
                                                height: 68,
                                                src: logo_login/* default */.Z,
                                                objectFit: "fill",
                                                alt: "Logo Arquiteto bolso",
                                                className: "imageLogo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxTitle, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                                                        children: [
                                                            "Do tamanho do seu ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "or\xe7amento"
                                                            }),
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                                                        children: [
                                                            "Gigante nas ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "primary",
                                                                children: "solu\xe7\xf5es"
                                                            }),
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxTinta, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                                                        greaterThan: "small",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_AnimaBalde, {}),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxImage, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "img/casal-login.png",
                                                                        alt: ""
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                                                        lessThan: "small",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxImage, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "img/casal-mobile.png",
                                                                    alt: ""
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                lg: 6,
                                className: "p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoxLogin, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLogin/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FormLogin, {
                                            setModalUrl: setModalUrl
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var templates_Auth = (Auth);


/***/ })

}]);